import axiosInstance from "@/api/axios-instance";
import { OrphanedSession } from "./get-orphaned-sessions";

export interface CompletedBundleSessionsResponse {
  sessions: OrphanedSession[];
}

export async function getCompletedBundleSessions(
  bundleUsageId: string
): Promise<CompletedBundleSessionsResponse> {
  const response = await axiosInstance.get(
    `/audit/completed-bundle-sessions/${bundleUsageId}`
  );
  return response.data;
}
